/* eslint-disable max-len */
import { setCookie, getCookie } from './cookies';
import showBSModal from '../vendor/bootstrap-modal-wrapper/bootstrap.modal.wrapper';
import formHandler from './formHandlers';

window.hos = country => {
  const modalBody = `<div class="modal-body pd-0x">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
    <div class="hold-on-stranger is-flex">
      <div class="col-md-7 pd-1i5x pd-t-2x bg-secondary">
        <h4 class="modal-title mg-b-0i5x">Hold on, Stranger!</h4>
        <p class="text-large">Are you as big a fan of cool data visualization as we are?<br />
          Before you leave, fill in your email and
          we'll send you industry news, tips and tricks and special offers.</p>
      </div>
      <div class="col-md-5 pd-1i5x pd-t-2x">
        <form id="hosForm"
          action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8">
          <input type="hidden" name="oid" value="00DA0000000K4Y2" readonly />
          <input type="hidden" name="retURL" value="" readonly />
          <input type="hidden" id="lead_source" name="lead_source" value="HoldOnStranger" readonly />
          <input type="hidden" id="00NA0000001qHx1" name="00NA0000001qHx1" value="HoldOnStranger"
            readonly />
          <input name="details" id="details" type="hidden" value="details" readonly />
          <input type="hidden" id="gaui" name="gaui" value="N/A" readonly />
          <input type="hidden" id="country" name="country" value="${country}" readonly />
          <div class="form-group">
            <input type="text" class="form-control input-lg" id="first_name" name="first_name" required
              placeholder="Enter your name here" />
          </div>
          <div class="form-group">
            <input type="email" class="form-control input-lg" id="email" name="email" required
              placeholder="Enter your e-mail here" />
          </div>
          <div class="form-group form-group-lg">
            <button id="submitBtn" type="submit" class="btn btn-block btn-lg btn-success disabled">
              Yes, I like good data visualizations
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>`;

  document.addEventListener('mouseout', event => {
    const e = event || window.event;
    const from = e.relatedTarget || e.toElement;
    if (!from || from.nodeName === 'HTML') {
      if (!document.querySelector('.hold-on-stranger') && getCookie('HoldOnStranger') === '') {
        showBSModal({
          id: 'hosModal',
          size: 'large',
          body: modalBody,
          onShow() {
            formHandler('hosForm', () => {
              setCookie('HoldOnStranger', true, 15);
            });
          },
          onHide() {
            document.getElementById('hosModal').remove();
            setCookie('HoldOnStranger', true, 15);
          }
        });
      }
    }
  });
};
